"use client";

import {
  WorkplaceRequestEventsParams,
  WorkplaceRequestEventsResponse
} from "@gettactic/api";
import { useInfiniteQuery } from "@tanstack/react-query";
import { api } from "@/lib/api/api";

export function useWorkplaceRequestEvents(
  ticketId: string,
  params: WorkplaceRequestEventsParams = {}
) {
  // Event timestamps are rendered as a wall clock in the requested `tz` with a
  // literal "Z" appended. Nothing here filters by date, so ask for UTC and the
  // values become real instants that `new Date` reads correctly.
  const queryParams = { ...params, tz: "UTC" };

  return useInfiniteQuery<WorkplaceRequestEventsResponse>({
    queryKey: ["workplaceRequestEvents", ticketId, queryParams],
    queryFn: async ({ pageParam }) => {
      const res =
        await api.client.workplaceRequestEvents.getWorkplaceRequestEvents(
          ticketId,
          {
            ...queryParams,
            cursor: pageParam as never
          }
        );
      return res.result as WorkplaceRequestEventsResponse;
    },
    initialPageParam: undefined,
    getNextPageParam: (lastPage) => lastPage?.cursor ?? undefined,
    enabled: !!ticketId
  });
}
